module.exports = __webpack_public_path__ + "img/16581307_S.d774215a.png";